module.exports = __webpack_public_path__ + "static/media/22ESCWA16.7fbab1f6.jpg";